import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";


const fetchAssetNo = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const [responseFems, responseBems] = await Promise.all([
      axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config),
      axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config)
    ]);
    const combinedData = [...responseFems.data, ...responseBems.data];
    return combinedData;
  }
  catch (error) {
    console.log(error);
  }
};

const fetchAssetNobyService = async (serviceType) => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    let response = [];
    if(serviceType === "FEMS" || serviceType === "fem"){
      response = await axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config);
    }else if (serviceType === "BEMS" || serviceType === "bem"){
      response = await axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config);
    }

    return response.data;
  }
  catch (error) {
    console.log(error);
  }
};

const fetchWorkRequestNo = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const [responseFems, responseBems] = await Promise.all([
      axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkRequestList/${facilityId},1,1000000`, config),
      axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkRequestList/${facilityId},1,1000000`, config)
    ]);

    const combinedData = [...responseFems.data, ...responseBems.data];
    return combinedData;
  }
  catch (error) {
    console.log(error);
  }
};

const lovOptions = async () => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${FemsGraph}/api/CommonLov/GetCommonLovList`, config);

    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchLocationCode = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${MasterGraph}/api/graph/GetUserLocationDetailsByFacilityId/${facilityId}?page=1&size=2000`, config);

    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchTypes = async (selectedCategory) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${FemsGraph}/api/Femworkrequesttypelist/Getworkrequestordertype/${selectedCategory}`, config);

    return response?.data;

  } catch (error) {
    console.error('Error fetching types:', error);
  }
};

const getBasicDetails = async (serviceType, basicdetailsdataId, categoryType) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const checkCategory = categoryType === "scheduled" ? "scheduledworkorderheaders" : "unscheduledworkorderheaders";

    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${basicdetailsdataId}`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const updateBasicDetails = async (serviceType, payload, categoryType) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}routineinspectionheaders/${payload?.id}`, payload, config);
    return response.data;
    
  } catch (error) {
    console.log(error);
    return error;
  }
};

const getWorkOrderSummary = async (serviceType, RIWorkorderId) => {
  const facilityId = getFacilityId('facilityId');

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const response = await axios.get(`${checkGraph}/api/RoutineInspection/GetRIWorkOrderId/${facilityId},${RIWorkorderId},${token}`, config);    
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const fetchItemCodeoptions = async (serviceType, categoryType) => {
  const facilityId = getFacilityId('facilityId');
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/GetWorkOrderItemDetailsFetchList/${facilityId},1,100000`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const getPartReplacementRows = async (serviceType, RIWorkOrderId) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${checkGraph}/api/RoutineInspection/GetRIwopartsreplaceList/${RIWorkOrderId},1,2000`, config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const addItemPartCode = async (serviceType, payload) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}routineinspectpartsreplacedetails`, payload, config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const updateItemPartCode = async (serviceType, payload, basicDetailsId) => {

  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}routineinspectpartsreplacedetails/${basicDetailsId}`, payload, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const deleteItemPartCode = async (serviceType, id) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.delete(`${checkGraph}/api/${checkFEMorBEM}routineinspectpartsreplacedetails/${id}`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};


const addCompletionInfo = async (serviceType, payload) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}routineinspectcompletiondetails`, payload, config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const updateCompletionInfo = async (serviceType, id, payload) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}routineinspectcompletiondetails/${id}`, payload, config);


    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const fetchEmployeeDetails = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId}`, config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchTaskCode = async (serviceType,workGroupId) => {
  const facilityId = getFacilityId('facilityId');
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/GetWOAssessmentTaskCodeFetchList/${facilityId},${workGroupId},1,100000`, config);
    return response.data;
  }
  catch (error) {
    console.log(error);
  }
};

const fetchVendorDetails = async () => {
  const companyId = getcompanyId('companyId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?Size=100000`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const addAssessmentsDetails = async (serviceType, payload) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}routineinspectassesmentheaders`, payload, config);

    return response.data;

  } catch (error) {
    console.log(error);
    return error;
  }
};

const updateAssessmentsDetails = async (serviceType, payload) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}routineinspectassesmentheaders/${payload?.id}`, payload, config);
    return response.data;

  } catch (error) {
    console.log(error);
    return error;
  }
};


const updateRIAssessmentsDetailsInWebForm = async (serviceType, payload) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/RoutineInspection`, payload, config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const sendVendorEmail = async (serviceType, payload) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/WorkOrderEmailSend`, payload, config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const getRepairDetails = async (serviceType, assessmentId) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    // Construct the API URL correctly with proper formatting
    const url = `${checkGraph}/api/RoutineInspection/GetRIworepairdetailsList/${assessmentId},1,2000`;

    // Make the API request
    const response = await axios.get(url, config);



    // Return the data from the API call to the calling function
    return response.data;
  } catch (error) {
    console.error('Error fetching repair details:', error);
    // Optionally throw the error to handle it in the calling function
    throw error;
  }
};

const addRepairTracker = async (serviceType, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}routineinspectrepairdetails`, payload, config);

    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const updateRepairTracker = async (serviceType, payload, categoryType, assementsId) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}routineinspectrepairdetails/${assementsId}`, payload, config);

    return response.data;

  } catch (error) {
    console.log(error);
  }
};


const deleteRepairTracker = async (serviceType,id) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.delete(`${checkGraph}/api/${checkFEMorBEM}routineinspectrepairdetails/${id}`, config);

    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const workorderStatusValue = async (serviceType, RIWorkOrderId, status, percentage) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
        "Content-Type": "application/json" // Ensure proper content type
      },
    };
    const response = await axios.put(`${checkGraph}/api/RoutineInspection/UpdateWorkOrderStatus/${RIWorkOrderId},${status},${percentage}`,{},config);

    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const workorderPushNotificationStatus = async (serviceType, RIWorkOrderId, status, percentage, Category) => {
  const facilityId = getFacilityId('facilityId');
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
        "Content-Type": "application/json" // Ensure proper content type
      },
    };
    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/UpdateWorkOrderPushNotificationStatus/${RIWorkOrderId},${status},${percentage},${Category},${facilityId}`,{},config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const autoAssignedEmp = async (serviceType, RIWorkOrderId) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${checkGraph}/api/${serviceType}unschworkorderaccepts/${RIWorkOrderId}`,config,);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};


const riRepository = {
  fetchAssetNo,
  fetchAssetNobyService,
  getWorkOrderSummary,
  updateBasicDetails,
  getBasicDetails,
  fetchWorkRequestNo,
  lovOptions,
  fetchTypes,
  fetchItemCodeoptions,
  addItemPartCode,
  getPartReplacementRows,
  updateItemPartCode,
  deleteItemPartCode,
  addCompletionInfo,
  updateCompletionInfo,
  fetchEmployeeDetails,
  fetchTaskCode,
  addAssessmentsDetails,
  updateAssessmentsDetails,
  updateRIAssessmentsDetailsInWebForm,
  getRepairDetails,
  addRepairTracker,
  updateRepairTracker,
  deleteRepairTracker,
  fetchVendorDetails,
  workorderStatusValue,
  workorderPushNotificationStatus,
  sendVendorEmail,
  autoAssignedEmp,
  fetchLocationCode
};

export default riRepository;